module.exports = __webpack_public_path__ + "static/img/fingerpost_refund_3.f37c087.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_refund_3.jpg
// module id = CNGI
// module chunks = 0